export default __webpack_public_path__ + "static/jellow-big-min-d65efc43e2004dfb760b8fe3558a3ad7.png";